<div class="vtr-ui-time-picker">
	<div class="row">
		<p class="sub-heading"
			id="{{linkId}}"
			role="text">
			{{ subHeadingText | translate | uppercase }}</p>
	</div>
	<div class="row">
		<div class="col-md-12 col-sm-12 pl-0">
			<div class="row">
				<div class="dropdown">
					<label [for]="id"
						id="ui-time-picker-label"
						attr.aria-label="{{label}}, {{hours[hour]}}, 'hours', {{minutes[minute]}}, 'minutes', {{amPms[amPm] | translate}}"
						[attr.aria-expanded]="showDropDown"
						#combo
						tabindex="0"
						class="dropbtn dropbtn-{{showDropDown}}"
						role="combobox"
						(click)="onToggleDropDown()"
						(keydown.enter)="onToggleDropDown()">
						<div class="row">
							<div class="col align-items-center d-flex justify-content-between">
								<div class="time-headings">
									<p class=""
										id="smartStandby-{{linkId}}-hours"
										role="text"
										attr.aria-label="hours">
										{{ 'device.deviceSettings.power.smartStandby.timer.timeUnits.unit1' | translate | uppercase }}
									</p>
									<span class=""
										role="text"
										id="{{linkId}}-hours-value">
										{{hours[hour]}}
									</span>
								</div>
								<div class="time-headings">
									<p class=""
										id="smartStandby-{{linkId}}-minutes"
										role="text"
										attr.aria-label="minutes">
										{{ 'device.deviceSettings.power.smartStandby.timer.timeUnits.unit2' | translate | uppercase }}
									</p>
									<span class=""
										role="text"
										id="{{linkId}}-minutes-value">
										{{minutes[minute]}}
									</span>
								</div>
								<div class="time-headings">
									<p class=""
										id="smartStandby-{{linkId}}-amPm"
										role="text"
										attr.aria-label="amPm">
										{{ 'device.deviceSettings.power.smartStandby.timer.timeUnits.unit3' | translate }}
									</p>
									<span class=""
										role="text"
										id="{{linkId}}-amPm-value">
										{{amPms[amPm] | translate}}
									</span>
								</div>

								<div class="toggle-icon align-right toggle-icon-{{showDropDown}}"
									id="smartStandby-{{linkId}}-dropDown-btn"
									role="button"
									attr.aria-label="{{linkId}}-dropDown">
									<fa-icon [icon]="['fal', 'chevron-down']"
										*ngIf="!showDropDown"
										role="img"
										aria-label="Arrow Down"
										alt="Arrow Down"></fa-icon>
									<fa-icon [icon]="['fal', 'chevron-up']"
										*ngIf="showDropDown"
										role="img"
										aria-label="Arrow Up"
										alt="Arrow Up"></fa-icon>
								</div>
							</div>
						</div>
					</label>

					<div *ngIf="showDropDown"
						class="dropdown-content">

						<div class="main-block">
							<div class="timer-block">
								<div class="row align-items-center d-flex justify-content-between">
									<div class="hours-block">

										<div class="toggle-icon"
											(click)="updateHours(false)"
											(mousedown)="$event.preventDefault()"
											(keydown.enter)="updateHours(false)"
											tabindex="0"
											role="button"
											id="smartStandby-{{linkId}}-hours-prev-btn"
											aria-label="smart standby hours arrow up">
											<fa-icon [icon]="['fal', 'chevron-up']"
												role="img"
												aria-label="Arrow Up"
												alt="Arrow Up"></fa-icon>
										</div>

										<span>{{hours[prevHour]}}</span><br>
										<span class="highlight"
											role="text"
											id="{{hours[copyHour]}}'hours'"
											attr.aria-label="{{hours[copyHour]}}, 'hours'">
											{{hours[copyHour]}}
										</span><br>
										<span>{{hours[nextHour]}}</span>

										<div class="toggle-icon"
											(click)="updateHours(true)"
											(mousedown)="$event.preventDefault()"
											(keydown.enter)="updateHours(true)"
											tabindex="0"
											role="button"
											id="smartStandby-{{linkId}}-hours-next-btn"
											aria-label="smart standby hours arrow down">
											<fa-icon [icon]="['fal', 'chevron-down']"
												role="img"
												aria-label="Arrow Down"
												alt="Arrow Down"></fa-icon>
										</div>

									</div>

									<div class="minutes-block">
										<div class="toggle-icon"
											(click)="updateMinutes(false)"
											(mousedown)="$event.preventDefault()"
											(keydown.enter)="updateMinutes(false)"
											id="smartStandby-{{linkId}}-minutes-prev-btn"
											tabindex="0"
											role="button"
											aria-label="smart standby minutes arrow up">
											<fa-icon [icon]="['fal', 'chevron-up']"
												role="img"
												aria-label="Arrow Up"
												alt="Arrow Up"></fa-icon>
										</div>

										<span>{{minutes[prevMinute]}}</span><br>
										<span class="highlight"
											role="text"
											id="{{minutes[copyMinute]}}, 'minutes'"
											attr.aria-label="{{minutes[copyMinute]}} 'minutes'">
											{{minutes[copyMinute]}}
										</span><br>
										<span>{{minutes[nextMinute]}}</span>

										<div class="toggle-icon"
											(click)="updateMinutes(true)"
											(mousedown)="$event.preventDefault()"
											(keydown.enter)="updateMinutes(true)"
											tabindex="0"
											role="button"
											id="smartStandby-{{linkId}}-minutes-next-btn"
											aria-label="smart standby minutes arrow down">
											<fa-icon [icon]="['fal', 'chevron-down']"
												role="img"
												aria-label="Arrow Down"
												alt="Arrow Down"></fa-icon>
										</div>

									</div>

									<div class="am-pm highlight"
										id="am-pm-highlight"
										role="radiogroup"
										aria-label="time list, select using arrow keys"
										tabindex="0">
										<span>
											<label class="inline-block"
												for="{{linkId}}-am-radio"
												attr.aria-label="{{ amPms[0] | translate }}"
												tabindex="0"
												[attr.aria-checked]="copyAmPm==0"
												(keydown.enter)="setAmPm(0)"
												(mousedown)="$event.preventDefault()">
												<input class="label-radio"
													id="{{linkId}}-am-radio"
													[name]="'ampmradio'+id"
													type="radio"
													value="0"
													tabindex="-1"
													[checked]="copyAmPm==0"
													(click)="setAmPm(0)"
													(mousedown)="$event.preventDefault()" />
												<p class="label-text"
													id="{{linkId}}-am-radio"
													role="text">{{ amPms[0] | translate }}</p>
											</label>
										</span>
										<span>
											<label class="inline-block"
												for="{{linkId}}-pm-radio"
												attr.aria-label="{{ amPms[1] | translate }}"
												[attr.aria-checked]="copyAmPm==1"
												tabindex="0"
												(keydown.enter)="setAmPm(1)"
												(mousedown)="$event.preventDefault()">
												<input class="label-radio"
													id="{{linkId}}-pm-radio"
													[name]="'ampmradio'+id"
													type="radio"
													tabindex="-1"
													value="1"
													[checked]="copyAmPm==1"
													(click)="setAmPm(1)"
													(mousedown)="$event.preventDefault()" />
												<p class="label-text"
													id="{{linkId}}-pm-radio"
													role="text">{{ amPms[1] | translate }}</p>
											</label>
										</span>
									</div>
									<div class="empty-block"></div>
								</div>
							</div>
						</div>
						<div class="d-flex justify-content-end py-3">
							<div class="select-close">
								<fa-icon [icon]="['fal', 'check']"
									tabindex="0"
									role="button"
									(click)="setTimer()"
									(mousedown)="$event.preventDefault()"
									(keydown.enter)="[setTimer(),combo.focus()]"
									id="smartStandby-{{linkId}}-done-icon"
									aria-label="'ok'"></fa-icon>
								<fa-icon [icon]="['fal', 'times']"
									tabindex="0"
									role="button"
									(click)="clearSettings()"
									(mousedown)="$event.preventDefault()"
									(keydown.enter)="[clearSettings(),combo.focus()]"
									(keydown.Tab)="[clearSettings(),combo.focus()]"
									id="smartStandby-{{linkId}}-close-icon"
									aria-label="'cancel'"></fa-icon>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
